<script setup lang="ts">
import type { IChecklistItem } from "@/interfaces";
import ButtonShadow from "@/stories/buttons/ButtonShadow/ButtonShadow.vue";

interface Props {
  item: IChecklistItem;
}

defineProps<Props>();

defineEmits<{ delete: [IChecklistItem] }>();
</script>

<template>
  <div
    class="border border-neutral300 rounded-2xl shadow-small py-1 px-4 flex justify-between items-center gap-2 bg-white cursor-grab"
  >
    <div><i class="ibg-icon ibg-reorder -mt-[2px]"></i></div>
    <div class="h300 flex-grow truncate">{{ item.title }}</div>
    <div>
      <ButtonShadow
        icon="far fa-trash-can text-lg"
        class="test-button-delete"
        :ariaLabel="
          $t('templates.wcag.delete_checklist_item', {
            title: item.title,
          })
        "
        @click="$emit('delete', item)"
      />
    </div>
  </div>
</template>
